document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initVariantPicker();
  initGallery();
  initBuyHighlight();
});

function initBuyHighlight() {
  if (window.location.hash !== '#mt-buy') return;
  var target = document.querySelector('.mt-pd__buy-btn--featured');
  var anchor = document.getElementById('mt-buy');
  if (!target || !anchor) return;
  anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
  window.setTimeout(function () {
    target.classList.add('mt-pd__buy-btn--pulse');
  }, 400);
}

function initReveal() {
  var items = document.querySelectorAll('.mt-reveal');
  if (!items.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    items.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('mt-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  items.forEach(function (el) { observer.observe(el); });
}

function initVariantPicker() {
  var root = document.querySelector('[data-mt-product]');
  if (!root) return;
  var variantsData = root.querySelector('[data-mt-variants]');
  if (!variantsData) return;
  var variants;
  try { variants = JSON.parse(variantsData.textContent); } catch (e) { return; }

  var optionInputs = root.querySelectorAll('[data-mt-option]');
  var idInput = root.querySelector('[data-mt-variant-id]');
  var qtyInput = root.querySelector('[data-mt-quantity]');
  var priceEl = root.querySelector('[data-mt-price]');
  var compareEl = root.querySelector('[data-mt-compare-price]');
  var addBtns = root.querySelectorAll('[data-mt-add]');

  addBtns.forEach(function (btn) {
    btn.dataset.mtLabel = btn.textContent.trim();
    btn.addEventListener('click', function () {
      if (qtyInput) qtyInput.value = btn.getAttribute('data-mt-qty') || '1';
    });
  });

  function currentVariant() {
    var selected = [];
    optionInputs.forEach(function (input) {
      if (input.checked) selected.push(input.value);
    });
    return variants.find(function (v) {
      return v.options.every(function (opt, i) { return opt === selected[i]; });
    });
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function update() {
    var variant = currentVariant();
    if (!variant) return;
    if (idInput) idInput.value = variant.id;
    if (priceEl) priceEl.textContent = formatMoney(variant.price);
    if (compareEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.textContent = formatMoney(variant.compare_at_price);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }
    addBtns.forEach(function (btn) {
      btn.disabled = !variant.available;
    });
  }

  optionInputs.forEach(function (input) {
    input.addEventListener('change', update);
  });
  update();
}

function initGallery() {
  var gallery = document.querySelector('[data-mt-gallery]');
  if (!gallery) return;
  var main = gallery.querySelector('[data-mt-gallery-main]');
  var thumbs = gallery.querySelectorAll('[data-mt-gallery-thumb]');
  if (!main || !thumbs.length) return;
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var src = thumb.getAttribute('data-full');
      if (!src) return;
      main.src = src;
      thumbs.forEach(function (t) { t.classList.remove('mt-thumb-active'); });
      thumb.classList.add('mt-thumb-active');
    });
  });
}
